"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m12 0a12 12 0 1 0 12 12 12 12 0 0 0 -12-12zm0 23a11 11 0 1 1 11-11 11 11 0 0 1 -11 11z",
    fill: "#1d1d1b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m16.24 6.4-7.06 8.6-1.42-1.71a1.18 1.18 0 1 0 -1.83 1.5l2.34 2.87a.24.24 0 0 0 .08.06 1 1 0 0 0 .08.11 1.51 1.51 0 0 0 .18.09.37.37 0 0 0 .12.07 1.22 1.22 0 0 0 .45.1 1.22 1.22 0 0 0 .45-.1.37.37 0 0 0 .12-.07 1.51 1.51 0 0 0 .18-.09 1 1 0 0 0 .08-.11.24.24 0 0 0 .08-.06l8-9.76a1.18 1.18 0 1 0 -1.83-1.5z",
    fill: "#93c01f"
  }));
};

exports["default"] = _default;